import React, { useEffect } from "react";
// import firstSectionImg2 from "../assests/firstSectionImg2.svg";
import aboutMeImage from "../assests/aboutMeImage.png";
import starImage from "../assests/starImage.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import outsourcingImg from '../assests/secondSectionBgImg.jpg'
export default function Outsourcing() {
  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("about_me");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
    });
  }, []);
  return (
    <div className="outsourcingMain" id="about_me">
      <div className="firstSection">
        <div className="firstSectionContainer">
          <div data-aos="fade-down-right" className="firstSectionChild2">
            <img
              className="zoom-effect"
              style={{ width: "100%" }}
              src={aboutMeImage}
              alt=""
            />
          </div>
          <div data-aos="fade-down-left" className="firstSectionChild1">
            <h1 className="firstSectionChild1Head">
              (CEO) EXPERIENCE AND JOURNEY
            </h1>
            <p className="text-white text-xl mb-3">Mr. Zulqarnain Mehmood</p>
            <p className="firstSectionChild1Para">
              In 1996, my journey in the real estate industry began with a small
              office. Over the experience of two years, by 1998, I expanded my
              venture, establishing 3 to 4 more offices. However, I eventually
              took a break to reflect on the path ahead. During this time, I
              gained valuable experience, and the unwavering support of my
              father and the constant presence of my younger brother by my side
              were instrumental. My father advised me to sell the property I
              owned at that time, and it marked a pivotal moment in my life. To
              pursue something bigger, we took a significant risk - we sold our
              own house and relocated to a rental property. With determination,
              I resumed my real estate journey, focusing on property buying and
              selling. Eventually, the day of triumph arrived when I initiated
              my first project in Lahore, a housing colony named GLG-I. The
              success of GLG-I paved the way for subsequent projects, including
              GLG-II, IDEAL AVENUE, and GALAXY AVENUE, all of which stand as
              testaments to our dedication and hard work.
            </p>
            {/* <button
              onClick={handleGetInTouch}
              className="firstSectionChild1Button"
            >
              Learn more
            </button> */}
          </div>

          {/* <div className="starImageContainer">
            <img style={{ width: "100%" }} src={starImage} alt="" />
          </div> */}
        </div>

        {/* <div data-aos="fade-up">
          <div className="firstSectionContainerTwo">
            <h1 className="firstSectionContainerTwoHead">
              HR Outsourcing & Manpower Supply Solutions Diverse Capabilities
            </h1>
            <p className="firstSectionContainerTwoPara  py-5 md:py-8 lg:py-3">
              With AM Global you can outsource your entire HR function or any
              specific HR services that you may need. We will work with you to
              develop a customized solution that meets your specific business
              needs with ease.
            </p>
          </div>
          <div className="outsourchingButtonContainer">
            <div className="outsourchingButton1">
              Efficient & Cost-Effective
            </div>
            <div className="outsourchingButton">
              Comprehensive Suite of Services
            </div>
            <div className="outsourchingButton">
              Experienced & Professional Team
            </div>
            <div className="outsourchingButton">
              Streamlined & Customized Solutions
            </div>
          </div>
        </div> */}
      </div>
      {/* <div className="">
        <div className="">
          <div className="secondSection">
            <img src={outsourcingImg} alt="" />
          </div>
        </div>
      </div> */}
    </div>
  );
}
